import { render } from "./AdminContainerList.vue?vue&type=template&id=2fabca8e"
import script from "./AdminContainerList.vue?vue&type=script&lang=js"
export * from "./AdminContainerList.vue?vue&type=script&lang=js"
script.render = render

export default script